import { createContext } from "react";

/**内容窗口高度上下文
 * [height,width]
 */
export const ContentSizeContext = createContext<ContentSizeData>(null as any);
export type ContentSizeData = [number, number];